import React from 'react'

import { Button, Modal, Form, Col, Row } from '_zari/core'
import { ZariContext } from '_zari/context'

import * as ActivosFijosService from 'services/activosFijos.service'

// El traslado no toca el valor del activo: solo dónde está y quién responde por él.
const TrasladoActivoModal = ({ handleClose, show, activo, onRegistrado }) => {
  const __zariContext = React.useContext(ZariContext)

  const [fecha, setFecha] = React.useState('')
  const [descripcion, setDescripcion] = React.useState('')
  const [idOficinaDestino, setIdOficinaDestino] = React.useState('')
  const [oficinaDestino, setOficinaDestino] = React.useState('')
  const [idUsuarioEntregadoA, setIdUsuarioEntregadoA] = React.useState('')
  const [usuarioEntregadoANombre, setUsuarioEntregadoANombre] = React.useState('')
  const [isSubmitting, setIsSubmitting] = React.useState(false)

  const submitHandler = async () => {
    setIsSubmitting(true)
    try {
      await ActivosFijosService.registrarTraslado(activo._id, {
        fecha: fecha,
        descripcion: descripcion,
        _idOficinaDestino: idOficinaDestino || undefined,
        oficinaDestino: oficinaDestino || undefined,
        _idUsuarioEntregadoA: idUsuarioEntregadoA || undefined,
        usuarioEntregadoANombre: usuarioEntregadoANombre || undefined
      })
      __zariContext.snack('success', 'Traslado registrado.')
      if (onRegistrado) onRegistrado()
      handleClose()
    } catch (err) {
      const error = err && err.data && err.data.error
      __zariContext.snack('error', error || 'No se pudo registrar el traslado.')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>TRASLADO</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={4}>
            <Form.Group>
              <Form.Label text='CODIGO' md={12} />
              <Col md={12}>
                <Form.InputText id='readonly-tras-codigo' disabled defaultValue={activo.codigo} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={8}>
            <Form.Group>
              <Form.Label text='DESCRIPCION' md={12} />
              <Col md={12}>
                <Form.InputText id='readonly-tras-descripcion' disabled defaultValue={activo.descripcion} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='UBICACION ACTUAL' md={12} />
              <Col md={12}>
                <Form.InputText id='readonly-tras-origen' disabled defaultValue={activo.oficina || '--'} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='RESPONSABLE ACTUAL' md={12} />
              <Col md={12}>
                <Form.InputText
                  id='readonly-tras-resp'
                  disabled
                  defaultValue={activo.usuarioEntregadoANombre || '--'}
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Form.Group>
          <Form.Label text='FECHA' htmlFor='input-tras-fecha' md={3} />
          <Col md={9}>
            <Form.InputDate
              id='input-tras-fecha'
              value={fecha}
              disabled={isSubmitting}
              onChange={e => setFecha(e.target.value)}
            />
          </Col>
        </Form.Group>
        <Form.Group>
          <Form.Label text='OFICINA DESTINO' htmlFor='input-tras-ofic' md={3} />
          <Col md={9}>
            <Form.InputText
              id='input-tras-ofic'
              value={oficinaDestino}
              disabled={isSubmitting}
              onChange={e => {
                setOficinaDestino(e.target.value)
                setIdOficinaDestino(e.target.value ? e.target.value : '')
              }}
            />
          </Col>
        </Form.Group>
        <Form.Group>
          <Form.Label text='RESPONSABLE DESTINO' htmlFor='input-tras-resp' md={3} />
          <Col md={9}>
            <Form.InputText
              id='input-tras-resp'
              value={usuarioEntregadoANombre}
              disabled={isSubmitting}
              onChange={e => {
                setUsuarioEntregadoANombre(e.target.value)
                setIdUsuarioEntregadoA(e.target.value ? e.target.value : '')
              }}
            />
          </Col>
        </Form.Group>
        <Form.Group>
          <Form.Label text='MOTIVO' htmlFor='input-tras-desc' md={3} />
          <Col md={9}>
            <Form.InputText
              id='input-tras-desc'
              value={descripcion}
              disabled={isSubmitting}
              onChange={e => setDescripcion(e.target.value)}
            />
          </Col>
        </Form.Group>
        <div className='text-muted small'>Indique al menos la oficina destino o el responsable.</div>
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' disabled={isSubmitting} onClick={handleClose}>
          Cancelar
        </Button>
        <Button disabled={isSubmitting} onClick={submitHandler}>
          Registrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default TrasladoActivoModal
